import { Observable } from 'rxjs';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { UndoCommand } from './command';
import { CommandEvents } from './command-events';
import { RendreMutualiseCommand } from './rendre-mutualise-command';

export class SupprimerMutualiseCommand implements UndoCommand<ObjetMaquette> {
    private reverseCommand: RendreMutualiseCommand;

    constructor(codeStructure: string, id: string, version: string, events: CommandEvents, objetMaquetteService: ObjetMaquetteService) {
        this.reverseCommand = new RendreMutualiseCommand(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.reverseCommand.undo();
    }

    undo(): Observable<ObjetMaquette> {
        return this.reverseCommand.do();
    }

    destroy(): void {
        this.reverseCommand.destroy();
    }
}
